<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('edit')}} {{ $tc('role', 1) }} {{ $t('access') }}</div>
      <router-link class="btn-blue" to="role-access">{{ $tc('role', 1) }} {{ $tc('list')}}</router-link>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedRole.label > 0 ? 'shift-up' : ''">{{selectedRole.label}}</label>
              <b-dropdown :text="selectedRole.label" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(role , rolekey) in Roles"
                  :key="rolekey"
                  @click="onSelectHandler('role',role)"
                >{{role.role_name}}</b-dropdown-item>
              </b-dropdown>
            </div>

            <Tooltip :title="$t('moviesearch')" />
          </div>
          <p class="error_msg">{{ $t('blankfieldmsg')}}</p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedModule.label > 0 ? 'shift-up' : ''">{{selectedModule.label}}</label>
              <b-dropdown :text="selectedModule.label" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(moduleItem , modulekey) in Modules"
                  :key="modulekey"
                  @click="onSelectHandler('moduleItem',moduleItem)"
                >{{moduleItem.module_name}}</b-dropdown-item>
              </b-dropdown>
            </div>

            <Tooltip :title="$t('moviesearch')" />
          </div>
          <p class="error_msg">{{ $t('blankfieldmsg')}}</p>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div v-for="(feature,featureKey) in Features" :key="featureKey" class="col-md-3">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input
                  v-on:click="onSelectHandler('feature',feature)"
                  type="checkbox"
                  :checked="selectedFeatures.indexOf(feature.feature_id) ? false : true"
                  class="custom-control-input"
                  :id="'customControlInline'+featureKey"
                />
                <label
                  class="custom-control-label"
                  :for="'customControlInline'+featureKey"
                >{{ feature.feature_name }}</label>
              </div>
            </div>
            <!-- <div class="col-md-3">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox" class="custom-control-input" id="customControlInline2" />
                <label
                  class="custom-control-label"
                  for="customControlInline2"
                >{{ $tc('feature', 1) }} 2</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox" class="custom-control-input" id="customControlInline3" />
                <label
                  class="custom-control-label"
                  for="customControlInline3"
                >{{ $tc('feature', 1) }} 3</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox" class="custom-control-input" id="customControlInline4" />
                <label
                  class="custom-control-label"
                  for="customControlInline4"
                >{{ $tc('feature', 1) }} 4</label>
              </div>
            </div>-->
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button v-on:click="updateRole()" class="btn-blue">{{ $t('update') }}</button>
          <button class="btn-black">{{ $t('reset') }}</button>
          <b-button class="btn-outline-grey" variant="default" to="role-access">{{ $t('cancel')}}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import UserPermission from "@/services/UserPermission";

export default {
  data() {
    return {
      role_featuresId: "",
      selectedRole: {
        label: "Select Role",
        value: ""
      },
      Roles: [],
      RolesMethod: {
        GET: "/admin/",
        tableName: "ms_roles",
        urlKey: "roles"
      },
      selectedModule: {
        label: "Select Module",
        value: ""
      },
      Modules: [],
      ModulesMethod: {
        GET: "/admin/",
        tableName: "ms_modules",
        urlKey: "modules"
      },
      Features: [],
      selectedFeatures: [],
      FeaturesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_features",
        urlKey: "features"
      }
    };
  },
  beforeMount() {
    this.getRolesList();
    this.getModulesList();
  },
  mounted() {
    const { role_featuresId } = this.$route.query;
    this.role_featuresId = this.$route.query.role_featuresId;
  },
  methods: {
    onSelectHandler: function(type, value) {
      if (type == "role") {
        this.selectedRole.label = value.role_name;
        this.selectedRole.value = value.role_id;
      } else if (type == "moduleItem") {
        this.selectedModule.label = value.module_name;
        this.selectedModule.value = value.module_id;
        this.getFeaturesList(value.module_id);
      } else if (type == "feature") {
        let index = this.selectedFeatures.indexOf(value.feature_id);
        if (index > -1) {
          this.selectedFeatures.splice(index, 1);
        } else {
          this.selectedFeatures.push(value.feature_id);
        }
      }
    },
    getRolesList: function() {
      this.Roles = [];
      let body = this.getRequestBody("GET", undefined, this.RolesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Roles = data.Records;
              this.getRoleById(this.role_featuresId);
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getModulesList: function() {
      this.Modules = [];
      let body = this.getRequestBody("GET", undefined, this.ModulesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Modules = data.Records;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getFeaturesList: function(module_id) {
      this.Features = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.FeaturesMethod,
        params: { id: "module_id-" + module_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Features = data.Records;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getRoleById: function(role_featuresId) {
      UserPermission.ReadRoleById(role_featuresId)
        .then(result => {
          const { data } = result;
          // console.log("data :", data);
          this.selectedRole.value = data[0].role_id;
          this.selectedModule.value = data[0].module_id;
          this.selectedFeatures.push(data[0].feature_id);
          this.getFeaturesList(data[0].module_id);

          this.Roles.map(x => {
            if (x.role_id == this.selectedRole.value) {
              this.selectedRole.label = x.role_name;
            }
          });
          this.Modules.map(x => {
            if (x.module_id == this.selectedModule.value) {
              this.selectedModule.label = x.module_name;
            }
          });
        })
        .catch(error => {
          console.log("error :", error);
        });
    },
    updateRole: function() {
      let payload = {
        role_id: this.selectedRole.value,
        feature_id: this.selectedFeatures.toString(),
        rf_is_active: "Y",
        role_featuresId: this.role_featuresId
      };
      UserPermission.UpdateRoleById(payload)
        .then(response => {
          const { data } = response;
          this.$router.go(-1);
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/RoleManagementContainer/RoleAccessComponents/editRoleAccess.vue